import { ConfigProvider } from 'antd';
import de_DE from 'antd/es/locale/de_DE';
import en_GB from 'antd/es/locale/en_GB';
import fr_FR from 'antd/es/locale/fr_FR';
import it_IT from 'antd/es/locale/it_IT';
import { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';

import { loadLocaleMessages } from '~/lib/localeMessages';
import { useDateFnsDefaultLocale } from '~/lib/useDateFnsDefaultLocale';
import { useStoreState } from '~/store/hooks';

interface LanguageWrapperProps {
    children: React.ReactNode;
}

export const LanguageWrapper = ({ children }: LanguageWrapperProps) => {
    const { locale } = useStoreState((state) => state.locale);
    useDateFnsDefaultLocale(locale);
    const [messages, setMessages] = useState({});

    useEffect(() => {
        let cancelled = false;
        void loadLocaleMessages(locale).then((localeMessages) => {
            if (!cancelled) {
                setMessages(localeMessages);
            }
        });
        return () => {
            cancelled = true;
        };
    }, [locale]);

    const getAntConfig = (locale: string) => {
        switch (locale) {
            case 'de':
                return de_DE;
            case 'fr':
                return fr_FR;
            case 'it':
                return it_IT;
            case 'en':
                return en_GB;
            default:
                console.error(`Unsupported locale: ${locale}`);
                return de_DE; // use de_DE as fallback locale
        }
    };

    return (
        <IntlProvider locale={locale} messages={messages}>
            <ConfigProvider locale={getAntConfig(locale)}>
                {children}
            </ConfigProvider>
        </IntlProvider>
    );
};
